import axios from "axios";
import * as userTypes from "../../types/admin/userTypes";
import {
  getAuthConfigAndCompanyId,
  handleApiError,
} from "../../../utils/authUtils";

export const createUserAction = (formData) => async (dispatch, getState) => {
  try {
    dispatch({
      type: userTypes.CREATE_USER_REQUEST,
    });

    const { companyId, config } = getAuthConfigAndCompanyId(getState());

    const { data } = await axios.post(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth/user/create`,
      formData,
      config
    );

    // Check if the API response indicates success
    if (data.success === false) {
      throw new Error(data.message || "Failed to create entity");
    }

    dispatch({
      type: userTypes.CREATE_USER_SUCCESS,
      payload: data?.data,
    });

    return data;
  } catch (error) {
    const err = handleApiError(error);
    dispatch({
      type: userTypes.CREATE_USER_FAIL,
      payload: err,
    });
    throw err;
  }
};

export const updateUserAction =
  (formData, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: userTypes.UPDATE_USER_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth/user/update/${userId}`,
        formData,
        config
      );

      // Check if the API response indicates success
      if (data.success === false) {
        throw new Error(data.message || "Failed to create entity");
      }

      dispatch({
        type: userTypes.UPDATE_USER_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: userTypes.UPDATE_USER_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const updateUserAuthAction =
  (formData, userId) => async (dispatch, getState) => {
    try {
      dispatch({
        type: userTypes.UPDATE_USER_AUTH_REQUEST,
      });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.put(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth/user/${userId}/auth-settings`,
        formData,
        config
      );

      // Check if the API response indicates success
      if (data.success === false) {
        throw new Error(data.message || "Failed to create entity");
      }

      dispatch({
        type: userTypes.UPDATE_USER_AUTH_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: userTypes.UPDATE_USER_AUTH_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getOneUserDataAction = (userId) => async (dispatch, getState) => {
  try {
    dispatch({ type: userTypes.GET_ONE_USER_REQUEST });

    const { companyId, config } = getAuthConfigAndCompanyId(getState());

    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth/user/${userId}`,
      config
    );

    if (data.success === false) {
      throw new Error(data.message || "Failed to get user data");
    }

    dispatch({
      type: userTypes.GET_ONE_USER_SUCCESS,
      payload: data?.data,
    });

    return data;
  } catch (error) {
    const err = handleApiError(error);
    dispatch({
      type: userTypes.GET_ONE_USER_FAIL,
      payload: err,
    });
    throw err;
  }
};

export const getOneUserAuthDataAction =
  (userId) => async (dispatch, getState) => {
    try {
      dispatch({ type: userTypes.GET_ONE_USER_AUTH_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth/user/${userId}/auth-settings`,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to get user auth data");
      }

      dispatch({
        type: userTypes.GET_ONE_USER_AUTH_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: userTypes.GET_ONE_USER_AUTH_FAIL,
        payload: err,
      });
      throw err;
    }
  };

export const getAllUserDataAction =
  (page, limit = 10, search = "") =>
  async (dispatch, getState) => {
    try {
      dispatch({ type: userTypes.GET_ALL_USER_REQUEST });

      const { companyId, config } = getAuthConfigAndCompanyId(getState());

      const { data } = await axios.get(
        `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth/user/all?page=${page}&limit=${limit}&search=${search}`,
        config
      );

      if (data.success === false) {
        throw new Error(data.message || "Failed to get user auth data");
      }

      dispatch({
        type: userTypes.GET_ALL_USER_SUCCESS,
        payload: data?.data,
      });

      return data;
    } catch (error) {
      const err = handleApiError(error);
      dispatch({
        type: userTypes.GET_ALL_USER_FAIL,
        payload: err,
      });
      throw err;
    }
  };


  export const userStatusChangeAction =
    (formData, userId) => async (dispatch, getState) => {
      try {
        dispatch({
          type: userTypes.UPDATE_USER_STATUS_REQUEST,
        });

        const { companyId, config } = getAuthConfigAndCompanyId(getState());

        const { data } = await axios.put(
          `${process.env.REACT_APP_BACKEND_URI}/api/admin/${companyId}/auth/user/status/${userId}`,
          formData,
          config
        );

        // Check if the API response indicates success
        if (data.success === false) {
          throw new Error(data.message || "Failed to create entity");
        }

        dispatch({
          type: userTypes.UPDATE_USER_STATUS_SUCCESS,
          payload: data?.data,
        });

        return data;
      } catch (error) {
        const err = handleApiError(error);
        dispatch({
          type: userTypes.UPDATE_USER_STATUS_FAIL,
          payload: err,
        });
        throw err;
      }
    };
